/* Lightbox-Galerie der Produktbilder.

   Umbau 02.09.2026 (Testerbericht): vorher lagen die Medien untereinander in
   einem senkrecht scrollenden Container. Am PC blaetterte man dadurch nach
   unten statt zur Seite, auf dem Handy waren die uebrigen Bilder gar nicht im
   Dokument (CSS display:none) und liessen sich deshalb nicht durchblaettern.

   Jetzt ist der Inhalt eine waagerechte Spur mit Einrastpunkten (CSS). Dieses
   Skript bringt nur die Bedienung dazu: zum aktiven Bild springen, Pfeile,
   Tastatur. Das Wischen auf dem Handy uebernimmt der Browser von selbst. */
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.spur = this.querySelector('[role="document"]');
        this.zurueck = this.querySelector('[data-media-prev]');
        this.vor = this.querySelector('[data-media-next]');

        this.zurueck?.addEventListener('click', () => this.blaettern(-1));
        this.vor?.addEventListener('click', () => this.blaettern(1));

        /* Tastatur am DOKUMENT lauschen, nicht am Fenster selbst: nach einem
           Klick auf einen Pfeil kann dieser ausgeblendet werden (am Anfang bzw.
           Ende der Reihe), der Fokus faellt dann auf den Seitenkoerper zurueck
           und ein Lauscher am Fenster bekaeme nichts mehr mit — gemessen am
           02.09.: die Pfeiltasten blieben nach dem letzten Bild wirkungslos. */
        this._taste = (e) => {
          if (!this.hasAttribute('open')) return;
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.blaettern(1);
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.blaettern(-1);
          }
        };
        document.addEventListener('keydown', this._taste);

        /* Beim Wischen die Pfeile mitfuehren (am Anfang/Ende ausblenden).
           Kein Zusatzpaket noetig — die Spur ist ein normaler Scroll-Bereich. */
        /* Dreht jemand das Handy, aendert sich die Kachelbreite — ohne
           Nachjustieren stuende die Spur danach zwischen zwei Bildern. */
        window.addEventListener('resize', () => {
          if (!this.hasAttribute('open')) return;
          this.zuIndex(this.aktiverIndex, true);
        });

        this.spur?.addEventListener('scroll', () => {
          if (this._warten) return;
          this._warten = true;
          requestAnimationFrame(() => {
            this._warten = false;
            this.pfeileAktualisieren();
          });
        });
      }

      get kacheln() {
        return this.spur ? Array.from(this.spur.children) : [];
      }

      /* Abstand einer Kachel vom linken Rand der Spur — ueber die tatsaechlichen
         Rechtecke statt ueber offsetLeft. offsetLeft zaehlt ab dem naechsten
         positionierten Vorfahren; das ist hier das fixiert positionierte
         Lightbox-Fenster und nicht die Spur, wodurch die Kachel um dessen
         Versatz daneben lag (gemessen: 1035 statt 1440). */
      versatzVon(el) {
        return this.spur.scrollLeft + (el.getBoundingClientRect().left - this.spur.getBoundingClientRect().left);
      }

      /** Index der Kachel, die dem Sichtfenster am naechsten liegt. */
      get aktiverIndex() {
        if (!this.spur) return 0;
        const mitte = this.spur.scrollLeft + this.spur.clientWidth / 2;
        let besterIndex = 0;
        let besterAbstand = Infinity;
        this.kacheln.forEach((el, i) => {
          const elMitte = this.versatzVon(el) + el.getBoundingClientRect().width / 2;
          const abstand = Math.abs(elMitte - mitte);
          if (abstand < besterAbstand) {
            besterAbstand = abstand;
            besterIndex = i;
          }
        });
        return besterIndex;
      }

      blaettern(richtung) {
        const kacheln = this.kacheln;
        if (!kacheln.length) return;
        const ziel = Math.min(kacheln.length - 1, Math.max(0, this.aktiverIndex + richtung));
        this.zuIndex(ziel);
      }

      zuIndex(i, sofort = false) {
        const el = this.kacheln[i];
        if (!el || !this.spur) return;
        const breite = el.getBoundingClientRect().width;
        const links = this.versatzVon(el) - (this.spur.clientWidth - breite) / 2;
        this.spur.scrollTo({ left: links, behavior: sofort ? 'auto' : 'smooth' });
        this.pfeileAktualisieren(i);
      }

      pfeileAktualisieren(index) {
        const anzahl = this.kacheln.length;
        const i = typeof index === 'number' ? index : this.aktiverIndex;
        // Bei nur einem Medium gibt es nichts zu blaettern.
        const zeigen = anzahl > 1;
        if (this.zurueck) this.zurueck.hidden = !zeigen || i <= 0;
        if (this.vor) this.vor.hidden = !zeigen || i >= anzahl - 1;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const gesuchteId = this.openedBy?.getAttribute('data-media-id');
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${gesuchteId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${gesuchteId}"]`);
        if (!activeMedia) {
          this.pfeileAktualisieren(0);
          return;
        }
        activeMedia.classList.add('active');

        /* Ohne Animation an die richtige Stelle springen: das Fenster oeffnet
           sich gerade erst, ein sichtbares Scrollen waere irritierend.
           Frueher stand hier scrollIntoView() plus eine Rechnung auf
           activeMedia.width — bei einem DIV (Video/3D) ist das undefiniert
           und die Spur blieb am Anfang stehen. */
        const index = this.kacheln.indexOf(activeMedia);
        const ziel = index < 0 ? 0 : index;
        this.zuIndex(ziel, true);
        /* Beim Oeffnen stehen die Bildgroessen oft noch nicht fest — die Bilder
           werden erst geladen, und jedes nachtraeglich eintreffende Bild
           verschiebt die Spur. Deshalb wird die Ausrichtung nachgezogen:
           einmal im naechsten Bildaufbau und danach nach jedem Bild, das
           fertig laedt. Ohne das startet die Galerie je nach Ladezeit um
           einige Pixel daneben und zeigt einen Streifen des Nachbarbilds. */
        this._zielIndex = ziel;
        requestAnimationFrame(() => this.zuIndex(ziel, true));
        this.kacheln.forEach((el) => {
          const bild = el.tagName === 'IMG' ? el : el.querySelector('img');
          if (bild && !bild.complete) {
            bild.addEventListener('load', () => this.zuIndex(this._zielIndex, true), { once: true });
          }
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
